import React from 'react';
import { Modal, Button } from 'grab-ui';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import css from './back-button-modal.less';

const BackButtonModal = ({ visible, onOk, onCancel }) => (
  <Modal
    className={css.backButtonModal}
    visible={visible}
    footer={null}
    closable={false}
  >
    <p className={css.header}>
      {I18n.t('v2.homepage.goBackConfirmModal.heading')}
    </p>
    <p className={css.body}>{I18n.t('v2.homepage.goBackConfirmModal.body')}</p>
    <div className={css.footer}>
      <Button onClick={onCancel} size="large">
        {I18n.t('v2.homepage.goBackConfirmModal.no')}
      </Button>
      <Button type="primary" onClick={onOk} size="large">
        {I18n.t('v2.homepage.goBackConfirmModal.yes')}
      </Button>
    </div>
  </Modal>
);

BackButtonModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default BackButtonModal;
